import { gql } from '@apollo/client';
import { forNotification } from '../subscriptions/Common/forNotification';
import { MobileStockLocationSession } from '../types/mobile_stock_location/mobileStockLocationSession';
import { forPaginated } from './common/paginated.graphql';

const session = gql`
  fragment MobileStockLocationSession on MobileStockLocationSession {
    id
    createdAt
    createdBy
    updatedAt
    updatedBy
    companyId
    stockLocationId
    status
    coordinates {
      latitude
      longitude
    }
  }
`;

const get = gql`
  query MobileStockLocationSessions($page: Float) {
    mobileStockLocationSessions(page: $page) {
      batchSize
      hasNext
      page
      pageSize
      data {
        ...MobileStockLocationSession
      }
    }
  }
  ${session}
`;

export interface GetMobileStockLocationSessionsVariables {
  page?: number;
}

class PaginatedMobileStockLocationSessions extends forPaginated<MobileStockLocationSession>() {}

const end = gql`
  mutation EndMobileStockLocationSession($sessionId: String!) {
    endMobileStockLocationSession(sessionId: $sessionId) {
      ...MobileStockLocationSession
    }
  }
  ${session}
`;

export interface GetMobileStockLocationSessionsResponse {
  mobileStockLocationSessions: PaginatedMobileStockLocationSessions;
}

export interface EndMobileStockLocationSessionVariables {
  sessionId: string;
}

export interface EndMobileStockLocationSessionResponse {
  endMobileStockLocationSession: MobileStockLocationSession;
}

const sessions = gql`
  subscription MobileStockLocationSessionNotification($companyId: String!, $stockLocationIds: [String!]) {
    mobileStockLocationSessionNotification(companyId: $companyId, stockLocationIds: $stockLocationIds) {
      companyId
      topic
      date
      entities {
        ...MobileStockLocationSession
      }
    }
  }
  ${session}
`;

export interface MobileStockLocationSessionNotificationVariables {
  companyId: string;
  stockLocationIds?: string[];
}

export class MobileStockLocationSessionNotificationResponse extends forNotification<MobileStockLocationSession>(
  'mobileStockLocationSessionNotification',
) {}

export const MobileStockLocationQueries = {
  get,
};

export const MobileStockLocationMutations = {
  end,
};

export const MobileStockLocationSubscriptions = {
  sessions,
};
